/**
 * Rollup does not support renamed exports so do not change this to export { Controller as InputControl } ...
 */
import { Controller } from 'react-hook-form';
export const InputControl = Controller;
